import React from 'react';
import Layout from "../common/Layout";
import Breadcrumb from "../common/breadcrumb/Breadcrumb";
import AboutUs from "../components/about-us/AboutUs";
import Testimonial from "../components/testimonial/Testimonial";
// import TeamMembers from "../components/team-members/TeamMembers";
import ClientLogo from "../components/client-logo/ClientLogo";
import {Helmet} from "react-helmet";

const AboutUsPage = () => {
    return (
        <>
            <Helmet>
                <title>About Us || Iron Wall X - Turkey's Leading Security Company</title>
                <meta name="description" content="Learn about Iron Wall X, Turkey's premier security company. Experienced professionals, cutting-edge technology, and proven track record in protecting businesses and individuals across Turkey." />
                <meta name="keywords" content="about Iron Wall X, Turkish security company, security experts Turkey, professional security services, security company history, trusted security Turkey" />
            </Helmet>
           <Layout>
               <Breadcrumb
                   pageTitle="About Us"
                   rootPath="/"
                   parentPath="Home"
                   currentPath="About"
               />
               <AboutUs/>
               <Testimonial/>
               {/* <TeamMembers/> */}
               <ClientLogo/>
           </Layout>
        </>
    );
};

export default AboutUsPage;